/**
 * Expose React and react-dom as globals so vendor shims (import map → vendor/*.js)
 * use the same instance. Must be imported before App so globals are set before any
 * @saviynt/* package or MFE code runs.
 */
import React from 'react';
import ReactDOM from 'react-dom';

if (typeof window !== 'undefined') {
  window.__SAVIYNT_MFE_REACT__ = React;
  window.__SAVIYNT_MFE_REACT_DOM__ = ReactDOM;

  // React audit: enable via localStorage 'react-audit'=1 or ?react-audit=1
  if (window.__REACT_AUDIT__) {
    window.__REACT_AUDIT__.register('host-bundle', React, 'Host (bundled React from node_modules)');
  }
}
